import "./BurgerButton.scss"

import React, { FC } from "react"

export interface BurgerButtonProps {
  opened: boolean
  clickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const BurgerButton: FC<BurgerButtonProps> = ({ opened, clickHandler }) => {
  return (
    <button
      type="button"
      className={`burger-button ${opened ? 'burger-button--open': ''}`}
      onClick={clickHandler}
    >
      <span className="burger-button__line"></span>
    </button>
  )
}
export default BurgerButton
